import React from "react";
import { genURL, GetCorServicei } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from "axios";

require('./../_css/PopUpOther.css');

export default class PopUpOther extends React.Component {

    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.state = {
            type: this.props.type,
            col: [],
            rows: [],
            valueRetuen: "",
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
            tData: []

        }
    }

    GetformatTimestamp = (date) => {
        var myDate = new Date(date);
        var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
        var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
        var year = myDate.getFullYear() + 543;
        return date1 + "/" + month + "/" + year;

    }
    Get_Data = async (event) => {
        this.setState({ w_code: "70" });
        this.setState({ w_id: "20" });
        var dataArray = [];
        var Url = "";
        if (event === "Deposit") {
            var DOCNO = this.Search.current.value;
            Url = "CSARDEPOSIT/CODE?ARCODE=" + this.props.ARCODE.trim() + "&DOCNO=" + DOCNO + "&TAXTYPE=" + this.props.TAXTYPE;
        } else if (event.key === "Enter") {
            var DOCNO = (event.target.value);
            Url = "CSARDEPOSIT/CODE?ARCODE=" + this.props.ARCODE.trim() + "&DOCNO=" + DOCNO + "&TAXTYPE=" + this.props.TAXTYPE;
            //Url = "CSINCOME/NAMETH?tablename="+this.props.from+"&name="+Expcode;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }


        await axios.get(genURL(Url)).then(res => {
            console.log(res)
            if (res.data.length >= 1) {
                for (let i = 0; i < res.data.length; i++) {
                    dataArray[i] = {
                        number: i + 1,
                        DEPOSITNO: res.data[i].DEPOSITNO,
                        DOCDATE: this.GetformatTimestamp(res.data[i].DOCDATE),
                        REMARK: res.data[i].REMARK,
                        DEBTAMOUNT: parseFloat(res.data[i].DEBTAMOUNT).toFixed(2),
                        DEBTBALANCE: parseFloat(res.data[i].DEBTBALANCE).toFixed(2),
                        SB: "0"
                    }
                }
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            } else {
                dataArray = [];
                this.setState({ col: dataArray });
                this.GetSearchTimeout();
            }
        });
    }
    GetSearchTimeout = () => {
        this.setState({ rows: this.state.col });
    }
    async componentDidMount() {
        var dataArray = [];
        switch (this.props.type) {
            case "Depositno":
                this.setState({ sh_Deposit: true });
                this.setState({ w_code: "70" });
                this.setState({ w_id: "20" });

                var Url = "CSARDEPOSIT/CODE?ARCODE=" + this.props.ARCODE.trim() + "&DOCNO=&TAXTYPE=" + this.props.TAXTYPE;
                await axios.get(genURL(Url)).then(res => {
                    console.log("res", genURL(Url));
                    if (res.data.length >= 1) {
                        for (let i = 0; i < res.data.length; i++) {
                            dataArray[i] = {
                                number: i + 1,
                                DEPOSITNO: res.data[i].DEPOSITNO,
                                DOCDATE: this.GetformatTimestamp(res.data[i].DOCDATE),
                                REMARK: res.data[i].REMARK,
                                DEBTAMOUNT: parseFloat(res.data[i].DEBTAMOUNT).toFixed(2),
                                DEBTBALANCE: parseFloat(res.data[i].DEBTBALANCE).toFixed(2),
                                SB: "0"
                            }
                        }
                        this.setState({ col: dataArray });
                        this.GetSearchTimeout();
                    }
                });

                this.setState({ col: dataArray, Htext: "ค้นหาใบรับเงินมัดจำ" });
                break;
        }
    }

    chkdata = (data) => {
        var redata = "";
        if (data) {
            redata = data;
        }
        return redata;
    }
    onSelectRow = (data, col, id) => {
        this.props.Get_PopUpOther3(data.DEPOSITNO);
        if (col > 1) {

            //เท่ากับเลือกรายการเมื่อคลิกแถว
            /* var dataArray = this.state.rows;
             dataArray[id].SB = "1";
             this.setState({rows:dataArray});*/
            //------------------------
            /* // for(var j = 0 ; j < this.state.rows.length && this.state.rows[j].DEPOSITNO ; j++){
                //  if(this.state.rows[j].SB === 1){
                  //    var Urlsub = "CSARDEPOSIT/DOCSUB?DOCNO="+this.state.rows[j].DEPOSITNO;
                      var Urlsub = "CSARDEPOSIT/DOCSUB?DOCNO="+data.DEPOSITNO;
                      GetCorServicei(Urlsub,"").then( res => {
                          if(res.data){
                              for(let i = 0 ; i < res.data.length ; i++){
                                  var datasend =
                                  this.chkdata(res.data[i].DOCNO)+"|"+
                                  this.chkdata(res.data[i].EXPCODE)+"|"+
                                  this.chkdata(res.data[i].EXPNAME)+"|"+
                                  this.chkdata(res.data[i].REMARK)+"|"+
                                  this.chkdata(res.data[i].AMOUNT)+"|"+
                                  this.chkdata(res.data[i].DEPARTMENT)+"|"+
                                  this.chkdata(res.data[i].SITECODE)
                                  this.props.Get_PopUpOther3(datasend);
                              }  
                          }  
                      });
                 // }
             // }*/

        }
    }
    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        // console.log(rowIndex)
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;

        }
        return (<div>{btnShow}</div>)
    }

    Update_Status = (Row, Status) => {
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });

                var dataArray = this.state.rows;

                for (var i = 0; i < this.state.rows.length && this.state.rows[i].DEPOSITNO; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });

            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });

                var dataArray = this.state.rows;
                for (var i = 0; i < this.state.rows.length && this.state.rows[i].DEPOSITNO; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {

            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            var dataArray = this.state.rows;
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });


            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DEPOSITNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }
    render() {
        return (

            <div className='popup'  >

                <br></br>
                <div className='popup_inner'>
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at" > {this.state.Htext} </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="right">
                        {this.state.sh_Deposit === true ?
                            <div className=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                                <input id="id1" type="text" className="form-control" ref={this.Search} onKeyPress={this.Get_Data.bind(null)} onBlur={this.Get_Data.bind(null, "Deposit")} />
                                <span id="iconsearch" className="input-group-addon icon"><i className="fas fa-search"></i></span>
                            </div>
                            : null
                        }
                        <div style={{ marginTop: "10px" }} >
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="700"
                                hover condensed  >
                                <TableHeaderColumn columnClassName="columnAll columnNumber" className="columnNumber" dataAlign="center" width="5%" dataField='number' isKey> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="5%" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} hidden> <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i style={{ fontSize: '20px' }} className={this.state.casschkbox} hidden> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="20%" dataField='DEPOSITNO'> เลขที่ใบรับ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DOCDATE' > วันที่รับ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="30%" dataField='REMARK' > หมายเหตุ </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DEBTAMOUNT' dataAlign="right" > จำนวนเงินทั้งสิ้น </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="15%" dataField='DEBTBALANCE' dataAlign="right"> ยอดคงเหลือ </TableHeaderColumn>
                                <TableHeaderColumn dataField='EXPCODE' hidden ></TableHeaderColumn>
                                <TableHeaderColumn dataField='EXPNAME' hidden ></TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}